(function () {
	'use strict';
	/*
	 * 	usage
	 * 	minDate:maxDate in jQuery datepicker format
	 *	0d:30d - shows from today to next 30 days
	 *	-1y:1y - shows from last year to next year
	 */
	//TODO: Add year range to display all the possible years
	angular.module('qbePortal').directive('qbDateValidation', [function () {
		return {
			restrict: 'A',
			require: 'ngModel',
			getDateUnit: function (u) {
				if (u === 'm') {
					return 'months';
				} else {
					return u;
				}
			},
			parseDate: function (dateString) {
				if (dateString !== '') {
					var unitSplit = dateString.match(/[a-zA-Z]+|[\-0-9]+/g);
					if (unitSplit.length === 2) {
						var dateUnit = this.getDateUnit(unitSplit[1]);
						dateString = moment().startOf('day').add(parseInt(unitSplit[0]), dateUnit);
					}
				}
				return dateString;
			},
			isValid: function (value, startDate, endDate) {
				var d = moment(value, 'DDMMYYYY');
				if (d.isValid()) {
					return moment(d).isBetween(startDate, endDate, null, '[]');
				}
				return false;
			},
			link: function (scope, element, attrs, ctrl) {

				var dateRange = attrs.qbDateValidation.split(':');

				//set start date and end date
				var startDate = (!!dateRange[0]) ? dateRange[0] : '';
				var endDate = (!!dateRange[1]) ? dateRange[1] : '';
				startDate = this.parseDate(startDate);
				endDate = this.parseDate(endDate);

				// bind enter key
				element.bind("keydown keypress", function (event) {
					if (event.which === 13 && !ctrl.$valid) {
						scope.$apply(function () {
							ctrl.$setViewValue(moment(startDate).startOf('day').format('DDMMYYYY'));
							ctrl.$render();
						});
						event.preventDefault();
					}
				});

				ctrl.$validators.date = function (modelValue) {
					return ctrl.$isEmpty(modelValue) || this.isValid(modelValue, startDate, endDate);
				}.bind(this);
			}
		}
	}]);
})();
